<template>
    <div class="text-center"  :dark="$store.getters.getColorPalette().isDark" >
        <!-- class="devc"  -->
        <v-btn text small outlined :dark="$store.getters.getColorPalette().isDark" :background-color="$store.getters.getColorPalette().background1ColorCode" :color="$store.getters.getColorPalette().btnborderColorCode" @click="dialog = !dialog">
            Edit User<v-icon right :dark="$store.getters.getColorPalette().isDark" :color="$store.getters.getColorPalette().accentCode">mdi-pencil</v-icon>
        </v-btn>
        <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card  :dark="$store.getters.getColorPalette().isDark" :color="$store.getters.getColorPalette().backgroundColorCode">
                <v-toolbar :dark="$store.getters.getColorPalette().isDark" :color="$store.getters.getColorPalette().foregroundColorCode">
                    <v-btn icon :dark="$store.getters.getColorPalette().isDark" @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
                    <v-toolbar-title>{{$store.getters.getTextMap().update_user}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn :dark="$store.getters.getColorPalette().isDark" text @click="dialog = false">{{$store.getters.getTextMap().close}}</v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <UpdateRootUser v-on:close="dialog=false" :user="user" />
            </v-card>
      </v-dialog>
    </div>
</template>
<script>
  import UpdateRootUser from '@/components/account_components/UpdateRootUser'
  export default {
      name:'EditRootUserModal',
      props:['user'],
      components:{
        UpdateRootUser  
      },
      data(){
          return {
              dialog:false
          }
      },
      methods:{
          
      }
  }
  </script>
  <style scoped>
  .devc{
     border:3px solid;
    border-radius:20px;
  
  }
  
  </style>